<template>
  <div class="animated fadeIn">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h3 class="mb-0">Analyte Ranges</h3>

      <div>
        <b-button @click="downloadTemplate" variant="primary" class="text-white mr-1">
          <b-spinner v-if="uploading" small></b-spinner>
          <i v-else class="fa fa-download"></i>
        </b-button>

        <b-button v-b-modal.import-file-modal variant="primary" class="text-white">
          <i class="fa fa-upload"></i>
          Import
        </b-button>
      </div>
    </div>

    <b-modal
      id="import-file-modal"
      title="Import Analyte Range"
      ok-title="Upload"
      hide-header-close
      no-close-on-backdrop
      no-close-on-esc
      @ok="uploadFile"
      :ok-disabled="uploading"
      :cancel-disabled="uploading"
    >
      <b-form-file
        v-model="importFile"
        :state="Boolean(importFile)"
        placeholder="Choose a file or drop it here..."
        drop-placeholder="Drop file here..."
      ></b-form-file>

      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button :disabled="uploading" @click="cancel" variant="danger">Cancel</b-button>

        <b-button :disabled="uploading" @click="ok" variant="success">
          <b-spinner v-if="uploading" small></b-spinner>
          <span v-else>Upload</span>
        </b-button>
      </template>
    </b-modal>

    <SampleTypeAnalyteRangeFormTissue
      v-if="sample_type.name === 'Tissue'"
      :sample_type="sample_type"
    />

    <SampleTypeAnalyteRangeFormSoil
      v-else-if="sample_type.name === 'Soil'"
      :sample_type="sample_type"
    />

    <SampleTypeAnalyteRangeFormFeed
      v-else-if="sample_type.name === 'Feed'"
      :sample_type="sample_type"
    />

    <SampleTypeAnalyteRangeFormWater
      v-else-if="sample_type.name === 'Water'"
      :sample_type="sample_type"
    />
  </div>
</template>

<script>
import Vue from 'vue'
import VueNotifications from 'vue-notifications'
import SampleTypeAnalyteRangeFormFeed from './form/SampleTypeAnalyteRangeFormFeed.vue'
import SampleTypeAnalyteRangeFormSoil from './form/SampleTypeAnalyteRangeFormSoil.vue'
import SampleTypeAnalyteRangeFormTissue from './form/SampleTypeAnalyteRangeFormTissue.vue'
import SampleTypeAnalyteRangeFormWater from './form/SampleTypeAnalyteRangeFormWater.vue'
import AnalyteRangeRepository from '@/repositories/lab/AnalyteRangeRepository'
import { notificationOptions } from '@/shared/toast-notification-options'
import { analyteRangeNotifications } from '@/shared/notifications'

Vue.use(VueNotifications, notificationOptions)

export default {
  name: 'SampleTypeAnalyteRangeForm',
  components: {
    SampleTypeAnalyteRangeFormTissue,
    SampleTypeAnalyteRangeFormSoil,
    SampleTypeAnalyteRangeFormFeed,
    SampleTypeAnalyteRangeFormWater
  },
  props: {
    sample_type: {
      type: Object,
      default: () => null
    }
  },
  data () {
    return {
      importFile: null,
      uploading: false,
      downloading: false
    }
  },
  methods: {
    async uploadFile (bvModalEvent) {
      bvModalEvent.preventDefault();
      this.uploading = true;

      try {
        await AnalyteRangeRepository.importFile(this.sample_type.id, this.importFile);
        this.$bvToast.toast('File uploaded successfully', {
          title: 'Success',
          variant: 'success',
          solid: true
        });
      } catch (error) {
        this.$bvToast.toast('Failed to upload file', {
          title: 'Error',
          variant: 'danger',
          solid: true
        });
      }
      
      this.uploading = false;
      this.importFile = null;
      this.$bvModal.hide('import-file-modal');
    },
    async downloadTemplate() {
      this.downloading = true;

      try {
        const { data } = await AnalyteRangeRepository.downloadImportTemplate(this.sample_type.id);

        // Decode the base64 string
        const binary = atob(data.file);
        const array = new Uint8Array(binary.length);
        for (let i = 0; i < binary.length; i++) {
          array[i] = binary.charCodeAt(i);
        }

        // Create a Blob from the array
        const blob = new Blob([array], { type: data.file_mime });

        // Create a URL for the Blob
        const url = window.URL.createObjectURL(blob);

        // Create a temporary <a> element to download the file
        const link = document.createElement('a');
        link.href = url;
        link.download = data.file_name;
        document.body.appendChild(link);
        link.click();

        // Cleanup
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.log(error);
        this.$bvToast.toast('Failed to download template', {
          title: 'Error',
          variant: 'danger',
          solid: true
        });
      }

      this.downloading = false;
    }
  },
  notifications: analyteRangeNotifications
}
</script>
